module.exports = __webpack_public_path__ + "static/img/Consulting06.993237dd.png";